module.exports = __webpack_public_path__ + "static/media/example-2.17239d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/MensHealthWA/example-2.jpg
// module id = 245
// module chunks = 0